import React from "react";
import { useTranslation } from "react-i18next";
import { FaBars, FaEdit, FaSignOutAlt, FaUser } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import { Dropdown } from "react-bootstrap";
import "../assets/css/Navbar.css";
import logo from "./logo.png";
import Swal from 'sweetalert2';
import NotificationsDropdown from "./common/NotificationsDropdown";


export default function Navbar({ onToggleSidebar }) {
  const { t, i18n } = useTranslation();
  const { logout } = useAuth();

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "de" : "en";
    i18n.changeLanguage(newLang);
  };

  const handleLogout = () => {
    Swal.fire({
      title: t('logout_confirm'),
      text: t('logout_message'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: t('yes_logout'),
      cancelButtonText: t('cancel')
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
      }
    });
  };

  return (
    <nav className="custom-navbar d-flex justify-content-between align-items-center px-3 py-2 shadow-sm bg-white">
      {/* اليسار */}
      <div className="navbar-start d-flex align-items-center">
        <button className="toggle-btn-nav me-3" onClick={onToggleSidebar}>
          <FaBars size={22} />
        </button>
        <img className="logo" src={logo} alt="Logo" />
      </div>

      {/* اليمين */}
      <div className="d-flex align-items-center">
        {/* زر اللغة */}
        <button className="lang-btn me-3" onClick={toggleLanguage}>
          {i18n.language === "en" ? "DE" : "EN"}
        </button>

        {/* الإشعارات */}
        <div className="me-3 d-flex align-items-center">
          <NotificationsDropdown />
        </div>


        {/* البروفايل */}
        <Dropdown align="end">
          <Dropdown.Toggle
            variant="link"
            className="profile-toggle d-flex align-items-center text-dark"
          >
            <div className="profile-icon d-flex justify-content-center align-items-center me-2">
              <FaUser size={16} />
            </div>
            <span className="fw-semibold">{t("profile")}</span>
          </Dropdown.Toggle>

          <Dropdown.Menu className="shadow-sm border-0 rounded-3 mt-2">
            <Dropdown.Item href="/admin/profile" className="d-flex align-items-center">
              <FaEdit className="me-2 text-primary" />
              {t("update_profile")}
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleLogout} className="d-flex align-items-center text-danger">
              <FaSignOutAlt className="me-2" />
              {t("logout")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </nav>
  );
}